import { h, Component } from 'preact';
import Pagination from './Pagination';
import { IOnBehalfSelectorProps, IOnBehalfSelectorState } from '../sgwt-super-header.types';

const ITEMS_PER_PAGE: number = 5;

export default class OnBehalfSelector extends Component<IOnBehalfSelectorProps, IOnBehalfSelectorState> {
  constructor(props: IOnBehalfSelectorProps) {
    super(props);
    this.state = this.getInitialState();
  }

  private countPages(list: object[]): number {
    return Math.max(Math.ceil(list.length / ITEMS_PER_PAGE), 1);
  }

  getInitialState(): IOnBehalfSelectorState {
    return {
      currentPage: 1,
      pagesCount: this.countPages(this.props.list),
      filteredList: this.props.list,
      from: 0,
      to: ITEMS_PER_PAGE - 1,
      search: '',
      sort: {
        column: '',
        order: ''
      }
    };
  }

  changePage(newPage: number) {
    const newFrom: number = (newPage - 1) * ITEMS_PER_PAGE;
    this.setState({
      currentPage: newPage,
      from: newFrom,
      to: newFrom + ITEMS_PER_PAGE - 1
    });
  }

  /**
   * Filter the list with the search made by the user, then re-sort the list.
   **/
  private filterAndSortList(search: string, column: string, order: string): object[] {
    const filteredList = this.props.list.filter((user: any) => {
      if (search) {
        // TODO Search on every field? At least on company name?
        return user.name.toLowerCase().includes(search) ||
          (user.hasOwnProperty('company') && user.company.toLowerCase().includes(search));
      }
      return true;
    });
    // Now order the list...
    return filteredList.sort((u1: any, u2: any) => {
      const a: string = u1[column];
      const b: string = u2[column];
      const factor = order === 'asc' ? -1 : 1;
      if (!a) {
        return -factor;
      }
      if (!b) {
        return factor;
      }
      return a.localeCompare(b) * factor;
    });
  }

  private searchValueChanged = (e: Event): void => {
    const search = (e.target as HTMLInputElement).value;
    const filteredList = this.filterAndSortList(search, this.state.sort.column, this.state.sort.order);

    this.setState({
      currentPage: 1,
      pagesCount: this.countPages(filteredList),
      from: 0,
      to: ITEMS_PER_PAGE - 1,
      filteredList: filteredList,
      search: search
    });
  };

  private sortList(column: string) {
    let order = 'desc';
    if (this.state.sort.column === column) {
      order = this.state.sort.order === 'desc' ? 'asc' : 'desc';
    }
    const filteredList = this.filterAndSortList(this.state.search, column, order);

    this.setState({
      currentPage: 1,
      pagesCount: this.countPages(filteredList),
      from: 0,
      to: ITEMS_PER_PAGE - 1,
      filteredList: filteredList,
      sort: {
        column: column,
        order: order
      }
    });
  }

  render(props: IOnBehalfSelectorProps, state: IOnBehalfSelectorState): JSX.Element {
    // Only look for the number of items
    let rows = state.filteredList.map((user: any, index: number) => {
      const included: boolean = index >= state.from && index <= state.to;
      return included ?
        <tr onClick={ () => props.onNavigateAsSelectUser(user) }>
          <td>{user.name}</td>
          <td>{user.company}</td>
        </tr>
        : undefined;
    });

    const {labels} = props;
    const from = state.from + 1;
    const to = Math.min(state.to + 1, state.filteredList.length);
    const legend = `${labels.legendShowing} ${from} ${labels.legendTo} ${to} ${labels.legendOf} ${state.filteredList.length} ${labels.legendEntries}`;

    return (
      <div class="sgwt-super-header-on-behalf-popover">
        <form role="form" autocomplete="off">
          <div class="form-group has-feedback">
            <input
              type="text"
              value={state.search}
              onInput={this.searchValueChanged}
              class="form-control"
              id="inputSearchOnBehalfUser"
              aria-describedby="inputSearchOnBehalfUser"
              placeholder={props.labels.searchPlaceholder}
            />
            <p
              class="fa fa-search form-control-feedback"
              style={{ top: '8px' }}
              aria-hidden="true"
            />
          </div>
        </form>

        {/* Search field */}
        <table class="table table-hover table-striped table-bordered">
          <thead>
          <tr>
            <th
              class={`order ${state.sort.column === 'name' ? ('order-' + state.sort.order) : ''}`}
              onClick={() => this.sortList('name')}>
              {props.labels.columnName}
            </th>
            <th
              class={`order ${state.sort.column === 'company' ? ('order-' + state.sort.order) : ''}`}
              onClick={() => this.sortList('company')}>
              {props.labels.columnCompany}
            </th>
          </tr>
          </thead>
          <tbody>{rows}</tbody>
        </table>
        <p>{legend}</p>
        <Pagination
          labels={props.labels}
          currentPage={state.currentPage}
          pagesCount={state.pagesCount}
          from={state.from}
          to={state.to}
          onPageChange={(page: number) => this.changePage(page)}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/sgwt-super-header/components/OnBehalfSelector.tsx